import { fetchCurrentUser } from '../../ducks/user.duck';
import { fetchFreeTransactions } from '../../util/api';
import { storableError } from "../../util/errors";
import { parse } from "../../util/urlHelpers";

// ================ Action types ================ //

export const FETCH_TRANSACTIONS_REQUEST = 'app/AdminPanelWalletPage/FETCH_TRANSACTIONS_REQUEST';
export const FETCH_TRANSACTIONS_SUCCESS = 'app/AdminPanelWalletPage/FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_ERROR = 'app/AdminPanelWalletPage/FETCH_TRANSACTIONS_ERROR';

const FREE_TRANSACTION_PER_PAGE = 10;

// ================ Reducer ================ //

const initialState = {
  transactions: [],
  pagination: null,
  fetchTransactionsError: null,
  updateTransactionError: null,
  transactionInProgress: false,
  updateTransactionProgress: false,
  fetchTransactionProgress: false,
  fetchTransactionError: null,
  totalPlatFormAmount: 0
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {

    case FETCH_TRANSACTIONS_REQUEST:
      return {
        ...state,
        transactionInProgress: true,
        fetchTransactionsError: null,
      };

    case FETCH_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactionInProgress: false,
        transactions: payload.data,
        pagination: payload.pagination,
        totalPlatFormAmount: payload.totalPlatFormAmount || 0
      };

    case FETCH_TRANSACTIONS_ERROR:
      return {
        ...state,
        transactionInProgress: false,
        fetchTransactionsError: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //



// Action Creators
export const fetchTransactionsRequest = () => ({ type: FETCH_TRANSACTIONS_REQUEST });
export const fetchTransactionsSuccess = response => ({
  type: FETCH_TRANSACTIONS_SUCCESS,
  payload: response
});
export const fetchTransactionsError = error => ({
  type: FETCH_TRANSACTIONS_ERROR,
  payload: error
});

// ================ Thunks ================ //
export const fetchTransactions = params => async (dispatch, getState, sdk) => {
  dispatch(fetchTransactionsRequest());
  try {
    console.log(params, "params")
    const {
      pageParams,
      payload,
      isAdmin = false
    } = params;
    const response = await fetchFreeTransactions({
      payload,
      pageParams,
      isAdmin
    });
    dispatch(fetchTransactionsSuccess(response));
    return response;
  } catch (error) {
    const errorMessage = storableError(error)
    dispatch(fetchTransactionsError(errorMessage));
    throw error;
  }
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  dispatch(fetchTransactionsRequest());
  const fetchCurrentUserOptions = {
    updateHasListings: false,
    updateNotifications: false,
  };

  const queryParams = parse(search);
  const { page = 1 } = queryParams;

  return dispatch(fetchCurrentUser(fetchCurrentUserOptions))
    .then(response => {
      const currentUser = getState().user.currentUser;

      dispatch(fetchTransactions(
        {
          payload: {
            // provider_id: currentUser?.id?.uuid
          },
          pageParams: {
            page,
            perPage: FREE_TRANSACTION_PER_PAGE
          },
          isAdmin: true
        }));
      return response;
    });
};
